// Box C — the "Stateless Router" in the architecture diagram.
//
// In production, this module would POST the anonymous 64-char token to the
// billing service via safeFetch and receive a JWT-signed subscription record.
// For v1 it is a local stub: the dev environment has no billing backend, and
// the user explicitly chose to stub Box C while building the local-first stack.
//
// The function signature is the production contract: only the anonymous token
// is accepted. There is no parameter for email/password/master-key by design.

import type { TenantTier } from '../../types/tenant';

export interface SubscriptionStatus {
  tier: TenantTier;
  /** Epoch ms when the cached entitlement expires. */
  expiresAt: number;
  features: readonly string[];
  /** True for the stub; production responses set this false. */
  isStub: boolean;
}

const STUB_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export async function checkSubscriptionStatus(anonToken: string): Promise<SubscriptionStatus> {
  if (!/^[0-9a-f]{64}$/.test(anonToken)) {
    throw new Error('anonToken must be a 64-character lowercase hex string');
  }
  // The token is referenced (and validated) so the production swap is a one-line change.
  void anonToken;
  return {
    tier: 'premium',
    expiresAt: Date.now() + STUB_TTL_MS,
    features: ['invoice-pdf', 'unlimited-taxpayers', 'white-label-branding'],
    isStub: true,
  };
}
